module.exports = __webpack_public_path__ + "static/img/icon_people.58b0ceca.svg";